import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from '../../../common/services/theme.service';

@Component({
    selector: 'maintenance-mode',
    templateUrl: './maintenance-mode.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaintenanceModeComponent implements OnInit, OnDestroy {
    constructor(private themeService: ThemeService) {}

    ngOnInit(): void {
        this.themeService.forceLightMode();
    }

    ngOnDestroy(): void {
        this.themeService.restoreTheme();
    }
}
